"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterService = void 0;
var singleton_1 = require("../class/singleton");
var helpers_1 = require("../helpers");
var Analytics_service_1 = require("./Analytics.service");
var RouterService = /** @class */ (function (_super) {
    __extends(RouterService, _super);
    function RouterService() {
        return _super.call(this) || this;
    }
    RouterService.prototype.init = function (router) {
        if (helpers_1.EnvironmentHelper.isClientSide()) {
            this.router = router;
        }
    };
    /** Go Back in history */
    RouterService.prototype.goBack = function () {
        var thereIsHistory = helpers_1.EnvironmentHelper.isClientSide() &&
            window.history &&
            window.history.length > 2;
        if (this.router && thereIsHistory) {
            this.router.back();
        }
        else if (thereIsHistory) {
            window.history.back();
        }
    };
    /** Go To a specific location */
    RouterService.prototype.goTo = function (path) {
        if (path) {
            if (this.router &&
                !helpers_1.UrlHelper.isAFullUrlWithQueryString(path) &&
                !helpers_1.UrlHelper.isRelativeUrl(path)) {
                this.router.push(path);
            }
            else if (helpers_1.EnvironmentHelper.isClientSide()) {
                window.location.href = path;
            }
        }
    };
    RouterService.prototype.getReferringUrl = function () {
        var esito = "";
        if (helpers_1.EnvironmentHelper.isClientSide()) {
            var protocol = window.location.protocol;
            var host = window.location.host;
            var path = this.router ? this.router.asPath : window.location.pathname;
            esito = "".concat(protocol, "//").concat(host).concat(path);
        }
        return esito;
    };
    RouterService.prototype.subscribeEvent = function (eventName, callback) {
        if (this.router) {
            this.router.events.on(eventName, callback);
        }
    };
    RouterService.prototype.unsubscribeEvent = function (eventName, callback) {
        if (this.router) {
            this.router.events.off(eventName, callback);
        }
    };
    RouterService.prototype.onRouteChangeStart = function (url) {
        var analyticsService = Analytics_service_1.AnalyticsService.getInstance();
        analyticsService.clearSourceDataLayer();
    };
    RouterService.prototype.onRouteChangeComplete = function (pageProps) {
        var analyticsService = Analytics_service_1.AnalyticsService.getInstance();
        var sendAnalyticsRetry = function (currentRetry) {
            if (currentRetry === void 0) { currentRetry = 0; }
            if (currentRetry < 3) {
                if (window["utag"] !== undefined) {
                    analyticsService.triggerPageView(pageProps);
                }
                else {
                    window.setTimeout(function () {
                        sendAnalyticsRetry(currentRetry + 1);
                    }, 500);
                }
            }
        };
        sendAnalyticsRetry();
    };
    RouterService.className = "RouterService";
    return RouterService;
}(singleton_1.Singleton));
exports.RouterService = RouterService;
